<!--
  @author:chen.hao
  @time:2018/11/25
  @disc:组织管理编辑/新增弹出层
 -->

<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show',false)">
    <el-form ref="form" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="上级" :required="true">{{info.parentName}}</el-form-item>
      <el-form-item label="组织/部门" prop="usType">{{['','组织','部门'][info.usType]}}</el-form-item>
      <el-form-item label="业务类型" :required="true">{{['','经营组织','职能组织'][info.orgType]}}</el-form-item>
      <template v-if="isBussinessOrg">
        <el-form-item label="业务准入" prop="adminType">
          {{adminType}}
        </el-form-item>
        <el-form-item label="//" prop="rebate">
          <el-radio-group v-model="form.rebate">
            <el-radio v-for="item in rebateArr" :label="item.value" :key="item.value">{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <el-form-item label="名称" prop="deptName">
        <el-input v-model="form.deptName" placeholder="请输入机构名称" maxlength="20" :disabled="isBussinessOrg"></el-input>
      </el-form-item>
      <el-form-item label="编码" prop="orgCode">
        <el-input v-model="form.orgCode" placeholder="请输入机构编码"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { checkCodeold } from '@/common/verify'
export default {
  name: 'addOrEditDialog',
  props: ['show', 'info'],
  data () {
    return {
      visible: false,
      form: {},
      usTypeArr: [
        { value: 1, label: '组织' },
        { value: 2, label: '部门' }
      ],
      orgTypeArr: [
        { value: 1, label: '经营组织' },
        { value: 2, label: '职能组织' }
      ],
      rebateArr: [
        { value: 1, label: '启用' },
        { value: 2, label: '关闭' }
      ],
      adminTypeArr: [
        { value: 1, label: '认证即可购买，客户归属根据区域划分' },
        { value: 2, label: '需要特殊资质审核，客户归属根据区域+渠道划分' }
      ],
      rules: {
        usType: [{ required: true, message: '请选择组织/部门' }],
        access: [{ required: true, message: '请选择业务准入' }],
        rebate: [{ required: true, message: '请选择//' }],
        deptName: [{ required: true, message: '名称不能为空' }],
        orgCode: [
          { required: true, message: '请输入编码' },
          { pattern: checkCodeold, message: '请输入6-20位字母或数字编码' }],
        adminType: [{ required: true, message: '请选择业务准入' }]
      }
    }
  },
  computed: {
    title () {
      return this.isEdit ? '编辑机构' : '新增机构'
    },
    isEdit () {
      return !!this.info.id
    },
    adminType () {
      let adminType = this.$lodash.find(this.adminTypeArr, { value: this.info.adminType })
      return adminType.label
    },
    isBussinessOrg () {
      return this.info.orgType === 1 && this.info.usType === 1
    }
  },
  methods: {
    ...mapActions(['addOrg', 'editOrg', 'getOrgTree']),
    handleSubmit () {
      this.$refs.form.validate(val => {
        if (val) {
          const action = this.isEdit ? this.editOrg : this.addOrg
          action({ ...this.form }).then(() => {
            this.getOrgTree()
            this.visible = false
          })
        }
      })
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.form = { ...this.info }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input, .el-select {
  width: 200px
}
</style>
